module.exports = __webpack_public_path__ + "static/img/David-Fusitua.dfad736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Fusitua.jpg
// module id = 4rYw
// module chunks = 0